export default __webpack_public_path__ + "static/media/deploy.63109849.png";